$(() => {
  const $body = $('body');

  $body.addClass('dom-ready');

  setTimeout(() => $body.addClass('page-loaded'), 300);

  // NOTE: use for automotive page
  $(window).bind('load', () => {
    $body.addClass('is-anim-ready');
  });
});
